<div class="aca-admin aca-exp" [class.aca-exp--embedded]="embedded">
  <aca-page-header *ngIf="!embedded" icon="event_busy" [title]="'DMS.DOCUMENT_EXPIRY.406BB1' | translate" [subtitle]="'DMS.UI.4C0651' | translate">
    <button type="button" class="aca-exp__outline" (click)="reload()" [disabled]="loading">
      <mat-icon>refresh</mat-icon>{{ 'DMS.DOCUMENT_EXPIRY.78A47D' | translate }}
    </button>
  </aca-page-header>

  <!-- embedded, the refresh sits with the list instead of in a header of its own -->
  <div class="aca-exp__embedbar" *ngIf="embedded">
    <button type="button" class="aca-exp__outline" (click)="reload()" [disabled]="loading">
      <mat-icon>refresh</mat-icon>{{ 'DMS.DOCUMENT_EXPIRY.78A47D' | translate }}
    </button>
  </div>

  <!-- ── summary ────────────────────────────────────────────────────────── -->
  <div class="aca-exp__stats">
    <button type="button" class="aca-exp__stat" [class.aca-exp__stat--on]="statusFilter === 'all'" (click)="statusFilter = 'all'">
      <span class="aca-exp__staticon aca-exp__staticon--blue"><mat-icon>event_note</mat-icon></span>
      <span class="aca-exp__stattext">
        <span class="aca-exp__statlabel">{{ 'DMS.DOCUMENT_EXPIRY.B1CAFA' | translate }}</span>
        <span class="aca-exp__statvalue">{{ countOf('all') | number }}</span>
        <span class="aca-exp__statunit"
          >{{ 'DMS.DOCUMENT_EXPIRY.B21E61' | translate }}<span *ngIf="sizeOf('all')"> · {{ sizeOf('all') }}</span></span
        >
      </span>
    </button>

    <button type="button" class="aca-exp__stat" [class.aca-exp__stat--on]="statusFilter === 'expired'" (click)="statusFilter = 'expired'">
      <span class="aca-exp__staticon aca-exp__staticon--red"><mat-icon>error_outline</mat-icon></span>
      <span class="aca-exp__stattext">
        <span class="aca-exp__statlabel">{{ 'DMS.DOCUMENT_EXPIRY.0B8CEE' | translate }}</span>
        <span class="aca-exp__statvalue">{{ countOf('expired') | number }}</span>
        <span class="aca-exp__statunit"
          >{{ 'DMS.DOCUMENT_EXPIRY.B21E61' | translate }}<span *ngIf="sizeOf('expired')"> · {{ sizeOf('expired') }}</span></span
        >
      </span>
    </button>

    <button type="button" class="aca-exp__stat" [class.aca-exp__stat--on]="statusFilter === 'soon'" (click)="statusFilter = 'soon'">
      <span class="aca-exp__staticon aca-exp__staticon--amber"><mat-icon>schedule</mat-icon></span>
      <span class="aca-exp__stattext">
        <span class="aca-exp__statlabel">{{ 'DMS.DOCUMENT_EXPIRY.FAF2EF' | translate }}</span>
        <span class="aca-exp__statvalue">{{ countOf('soon') | number }}</span>
        <span class="aca-exp__statunit"
          >{{ 'DMS.DOCUMENT_EXPIRY.B21E61' | translate }}<span *ngIf="sizeOf('soon')"> · {{ sizeOf('soon') }}</span></span
        >
      </span>
    </button>

    <button type="button" class="aca-exp__stat" [class.aca-exp__stat--on]="statusFilter === 'active'" (click)="statusFilter = 'active'">
      <span class="aca-exp__staticon aca-exp__staticon--green"><mat-icon>check_circle</mat-icon></span>
      <span class="aca-exp__stattext">
        <span class="aca-exp__statlabel">{{ 'DMS.DOCUMENT_EXPIRY.FA4E77' | translate }}</span>
        <span class="aca-exp__statvalue">{{ countOf('active') | number }}</span>
        <span class="aca-exp__statunit"
          >{{ 'DMS.DOCUMENT_EXPIRY.B21E61' | translate }}<span *ngIf="sizeOf('active')"> · {{ sizeOf('active') }}</span></span
        >
      </span>
    </button>
  </div>

  <div class="aca-exp__body">
    <section class="aca-exp__main">
      <!-- ── filters ──────────────────────────────────────────────────── -->
      <div class="aca-exp__filterbar">
        <label class="aca-exp__searchfilter">
          <mat-icon>search</mat-icon>
          <input type="text" [(ngModel)]="search" [placeholder]="'DMS.DOCUMENT_EXPIRY.85C076' | translate" autocomplete="off" />
        </label>

        <label class="aca-exp__filter">
          <span class="aca-exp__filterlabel">{{ 'DMS.DOCUMENT_EXPIRY.9A4FA6' | translate }}</span>
          <select class="aca-exp__select" [(ngModel)]="statusFilter">
            <option *ngFor="let filter of filters" [value]="filter.key">{{ filter.label | translate }}</option>
          </select>
        </label>

        <span class="aca-exp__count"
          >{{ 'DMS.UI.1D31FB' | translate }} {{ filtered().length | number }} {{ 'DMS.UI.F2DB2C' | translate }} {{ docs.length | number }}
          {{ 'DMS.UI.4514CB' | translate }}</span
        >
      </div>

      <!-- bulk bar: appears the moment anything is checked -->
      <div class="aca-exp__bulk" *ngIf="selCount()">
        <span class="aca-exp__bulkcount">{{ 'DMS.UI.RET_SEL_COUNT' | translate: { p0: selCount() } }}</span>
        <button type="button" class="aca-exp__outline" (click)="bulkEdit()" [disabled]="busyId === '*'">
          <mat-icon>edit_calendar</mat-icon>{{ 'DMS.UI.RET_BULK_EDIT' | translate }}
        </button>
        <button type="button" class="aca-exp__outline" (click)="bulkTrash()" [disabled]="busyId === '*'">
          <mat-icon>delete_outline</mat-icon>{{ 'DMS.UI.RET_BULK_ARCHIVE' | translate }}
        </button>
        <button type="button" class="aca-exp__outline" (click)="clearSel()" [disabled]="busyId === '*'">
          <mat-icon>close</mat-icon>{{ 'DMS.UI.RET_CLEAR_SEL' | translate }}
        </button>
      </div>

      <!-- ── table ────────────────────────────────────────────────────── -->
      <aca-page-state
        *ngIf="!loading && !filtered().length"
        state="empty"
        icon="event_busy"
        [title]="'DMS.DOCUMENT_EXPIRY.D2472B' | translate"
        [message]="'DMS.UI.C5D714' | translate"
      />

      <div class="aca-exp__card" *ngIf="filtered().length">
        <div class="aca-exp__tablewrap">
          <table class="aca-exp__table">
            <thead>
              <tr>
                <th class="aca-exp__th aca-exp__th--sel">
                  <input
                    type="checkbox"
                    class="aca-exp__check"
                    [checked]="allSel()"
                    [indeterminate]="someSel()"
                    (change)="toggleAll()"
                    [attr.aria-label]="'DMS.UI.RET_SELECT_ALL' | translate"
                  />
                </th>
                <th class="aca-exp__th aca-exp__th--name">{{ 'DMS.DOCUMENT_EXPIRY.85B482' | translate }}</th>
                <th class="aca-exp__th">{{ 'DMS.DOCUMENT_EXPIRY.AEABC8' | translate }}</th>
                <th class="aca-exp__th">{{ 'DMS.DOCUMENT_EXPIRY.9CFD2F' | translate }}</th>
                <th class="aca-exp__th">{{ 'DMS.DOCUMENT_EXPIRY.F51C27' | translate }}</th>
                <th class="aca-exp__th">{{ 'DMS.DOCUMENT_EXPIRY.55CFFC' | translate }}</th>
                <th class="aca-exp__th">{{ 'DMS.DOCUMENT_EXPIRY.2E8C46' | translate }}</th>
                <th class="aca-exp__th aca-exp__th--actions">{{ 'DMS.DOCUMENT_EXPIRY.6D5E7B' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="aca-exp__row" [class.aca-exp__row--sel]="isSel(doc)" *ngFor="let doc of filtered(); trackBy: trackById">
                <td class="aca-exp__td aca-exp__td--sel">
                  <input type="checkbox" class="aca-exp__check" [checked]="isSel(doc)" (change)="toggleSel(doc)" [attr.aria-label]="doc.name" />
                </td>
                <td class="aca-exp__td aca-exp__td--name">
                  <span class="aca-exp__badge" [ngClass]="badgeClass(doc)">{{ badge(doc) }}</span>
                  <span class="aca-exp__namebox">
                    <span class="aca-exp__name">{{ doc.name }}</span>
                    <span class="aca-exp__path">{{ doc.documentCode || doc.path }}</span>
                  </span>
                </td>

                <td class="aca-exp__td">{{ doc.documentType ? (typeLabel(doc.documentType) | translate) : '—' }}</td>

                <td class="aca-exp__td">
                  <span class="aca-exp__user" *ngIf="doc.owner; else noOwner">
                    <span class="aca-exp__avatar">{{ initial(doc.owner) }}</span
                    >{{ doc.owner }}
                  </span>
                  <ng-template #noOwner>—</ng-template>
                </td>

                <td class="aca-exp__td aca-exp__td--date" [ngClass]="'aca-exp__td--' + doc.status">
                  {{ doc.expiry | acaDate: 'd MMM y' }}
                </td>

                <td class="aca-exp__td" [ngClass]="'aca-exp__td--' + doc.status">{{ daysLabel(doc) }}</td>

                <td class="aca-exp__td">
                  <span class="aca-exp__chip" [ngClass]="'aca-exp__chip--' + doc.status">{{ statusLabel(doc.status) | translate }}</span>
                </td>

                <td class="aca-exp__td aca-exp__td--actions">
                  <span class="aca-exp__acts">
                    <button
                      type="button"
                      class="aca-exp__act aca-exp__act--open"
                      (click)="open(doc)"
                      [matTooltip]="'DMS.DOCUMENT_EXPIRY.83482B' | translate"
                      [attr.aria-label]="'DMS.DOCUMENT_EXPIRY.83482B' | translate"
                    >
                      <mat-icon>open_in_new</mat-icon>
                    </button>
                    <button
                      type="button"
                      class="aca-exp__act aca-exp__act--edit"
                      (click)="edit(doc)"
                      [matTooltip]="'DMS.DOCUMENT_EXPIRY.B6BAB7' | translate"
                      [attr.aria-label]="'DMS.DOCUMENT_EXPIRY.B6BAB7' | translate"
                      [disabled]="busyId === doc.id"
                    >
                      <mat-icon>edit_calendar</mat-icon>
                    </button>
                    <button
                      type="button"
                      class="aca-exp__act aca-exp__act--archive"
                      (click)="trash(doc)"
                      [matTooltip]="'DMS.DOCUMENT_EXPIRY.914D4F' | translate"
                      [attr.aria-label]="'DMS.DOCUMENT_EXPIRY.914D4F' | translate"
                      [disabled]="busyId === doc.id"
                    >
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <!-- ── settings panel ─────────────────────────────────────────────── -->
    <aside class="aca-exp__panel">
      <h3 class="aca-exp__paneltitle">{{ 'DMS.DOCUMENT_EXPIRY.7B2C93' | translate }}</h3>

      <div class="aca-exp__setting">
        <h4>{{ 'DMS.DOCUMENT_EXPIRY.9C1E7E' | translate }}</h4>
        <p>
          {{ 'DMS.DOCUMENT_EXPIRY.14144B' | translate }}<strong>{{ 'DMS.DOCUMENT_EXPIRY.9485D6' | translate }}</strong
          >{{ 'DMS.DOCUMENT_EXPIRY.97C6C0' | translate }}
        </p>
      </div>

      <div class="aca-exp__setting">
        <h4>{{ 'DMS.DOCUMENT_EXPIRY.0A5FA3' | translate }}</h4>
        <p>
          {{ 'DMS.DOCUMENT_EXPIRY.394CA6' | translate }}<code>cm:to</code>{{ 'DMS.DOCUMENT_EXPIRY.F76523' | translate }}<code>cm:effectivity</code
          >{{ 'DMS.DOCUMENT_EXPIRY.842861' | translate }}
        </p>
      </div>

      <div class="aca-exp__setting">
        <h4>{{ 'DMS.UI.RET_AUTO' | translate }}</h4>
        <p>{{ 'DMS.UI.RET_AUTO_NOTE' | translate }}</p>

        <ng-container *ngIf="automation() as auto">
          <ul class="aca-exp__checks">
            <li [class.aca-exp__check--on]="auto.service">
              <mat-icon>{{ auto.service ? 'check_circle' : 'cancel' }}</mat-icon>
              <span>{{ (auto.service ? 'DMS.UI.RET_AUTO_SERVICE_UP' : 'DMS.UI.RET_AUTO_SERVICE_DOWN') | translate }}</span>
            </li>
            <li [class.aca-exp__check--on]="auto.job?.enabled">
              <mat-icon>{{ auto.job?.enabled ? 'check_circle' : 'cancel' }}</mat-icon>
              <span>{{ (auto.job?.enabled ? 'DMS.UI.RET_AUTO_ON' : 'DMS.UI.RET_AUTO_OFF') | translate }}</span>
            </li>
            <li *ngIf="auto.job?.enabled && auto.nextRun" class="aca-exp__check--info">
              <mat-icon>schedule</mat-icon>
              <span>{{ 'DMS.UI.RET_AUTO_NEXT' | translate: { p0: (auto.nextRun | acaDate: 'd MMM y HH:mm') } }}</span>
            </li>
            <li *ngIf="auto.running" class="aca-exp__check--info">
              <mat-icon>autorenew</mat-icon>
              <span>{{ 'DMS.UI.RET_AUTO_RUNNING' | translate }}</span>
            </li>
            <li *ngIf="auto.lastRun as run" class="aca-exp__check--info">
              <mat-icon>history</mat-icon>
              <span>{{
                'DMS.UI.RET_AUTO_LAST' | translate: { p0: (run.finishedAt | acaDate: 'd MMM y HH:mm'), p1: run.processed, p2: run.errors.length }
              }}</span>
            </li>
          </ul>

          <div class="aca-exp__autoactions">
            <button type="button" class="aca-exp__outline" (click)="setAutomation(!auto.job?.enabled)" [disabled]="autoBusy()">
              <mat-icon>{{ auto.job?.enabled ? 'pause_circle' : 'play_circle' }}</mat-icon>
              {{ (auto.job?.enabled ? 'DMS.UI.RET_AUTO_DISABLE' : 'DMS.UI.RET_AUTO_ENABLE') | translate }}
            </button>
            <button
              *ngIf="auto.job?.enabled && auto.service"
              type="button"
              class="aca-exp__outline"
              (click)="runAutomation()"
              [disabled]="autoBusy() || auto.running"
            >
              <mat-icon>bolt</mat-icon>
              {{ 'DMS.UI.RET_AUTO_RUN' | translate }}
            </button>
          </div>
        </ng-container>
      </div>

      <div class="aca-exp__setting">
        <h4>{{ 'DMS.UI.RET_TRASH' | translate }}</h4>
        <p>{{ 'DMS.UI.RET_TRASH_NOTE' | translate }}</p>
      </div>
    </aside>
  </div>
</div>
